module.exports = __webpack_public_path__ + "static/Prof.Yong-KooKangMDPhDKOREA-a98c2791fb370248245393c2ab896a27.jpg";